import React from "react";

function BlueRightIcon() {
    return (
        <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.00056 1.00594C3.27334 0.694337 3.74748 0.662901 4.05916 0.935623L8.05916 4.43562C8.22183 4.57803 8.31502 4.78386 8.31502 5.00008C8.31502 5.21629 8.22183 5.42212 8.05916 5.56453L4.05916 9.06453C3.74748 9.33725 3.27334 9.30582 3.00056 8.99422C2.72784 8.68254 2.75928 8.2084 3.07088 7.93562L6.42537 5.00008L3.07088 2.06453C2.75928 1.79175 2.72784 1.31762 3.00056 1.00594Z"
                fill="#0076F7"
            />
        </svg>
    );
}

export default BlueRightIcon;
